import clsx from 'clsx';
import * as React from 'react';
import { Link } from 'react-router-dom';

import { Trash, Help } from '@ovpn-ui/icons';
import {
    Breadcrumbs,
    Anchor,
    Header,
    ButtonGroup,
    Button,
    IconButton,
    Tooltip,
} from '@ovpn-ui/core';

import { useLayout } from '../../hooks';
import { ExpandableSearch } from '../ExpandableSearch';

import { PageHeaderProps } from './PageHeader.types';
import { ResponsiveButtonGroup, PageHeaderWrapper } from './PageHeader.styles';

export function PageHeader({
    title,
    description,
    breadcrumbs,
    ctaButton,
    ctaTooltipProps = {},
    deleteButton,
    helpButton,
    search,
    className,
}: PageHeaderProps) {
    const { isMobile } = useLayout();

    const hasActions = !!(ctaButton || deleteButton || helpButton || search);

    return (
        <PageHeaderWrapper className={clsx('page-header', className)}>
            {Array.isArray(breadcrumbs) && breadcrumbs.length > 0 && (
                <Breadcrumbs>
                    {breadcrumbs.map((t, i) => (
                        <Anchor as={Link} key={i} {...t} />
                    ))}
                </Breadcrumbs>
            )}
            <ResponsiveButtonGroup>
                <Header title={title} description={description} />
                {hasActions && (
                    <ButtonGroup className="header-actions">
                        {ctaButton && (
                            <Tooltip
                                placement="bottom"
                                {...ctaTooltipProps}
                                trigger={
                                    <Button
                                        {...ctaButton}
                                        className={clsx('header-cta-btn', ctaButton.className)}
                                    />
                                }
                            >
                                {ctaButton['aria-label'] ?? ctaTooltipProps?.children}
                            </Tooltip>
                        )}
                        {deleteButton &&
                            (isMobile ? (
                                <Button
                                    variant="ghost"
                                    {...deleteButton}
                                    className={clsx('header-delete-btn', deleteButton.className)}
                                >
                                    <Trash strokeWidth={1.5} />
                                    {deleteButton['aria-label']}
                                </Button>
                            ) : (
                                <IconButton
                                    variant="ghost"
                                    {...deleteButton}
                                    className={clsx('header-delete-btn', deleteButton.className)}
                                >
                                    <Trash strokeWidth={1.5} />
                                </IconButton>
                            ))}
                        {search && <ExpandableSearch {...search} />}
                        {helpButton && (
                            <IconButton
                                variant="ghost"
                                {...helpButton}
                                className={clsx('header-help-btn', helpButton.className)}
                            >
                                <Help strokeWidth={1.5} />
                            </IconButton>
                        )}
                    </ButtonGroup>
                )}
            </ResponsiveButtonGroup>
        </PageHeaderWrapper>
    );
}
